import { render, staticRenderFns } from "./EventCoP.vue?vue&type=template&id=0e68442a&scoped=true"
import script from "./EventCoP.vue?vue&type=script&lang=js"
export * from "./EventCoP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e68442a",
  null
  
)

export default component.exports